// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')

const defaultBemEntity = BemEntity('SimpleNav')

// SimpleNavItem component

function SimpleNavItem(props) {
  const bemEntity = props.bemEntity || defaultBemEntity
  return React.createElement('a', {
    className: bemEntity.element('item', {
      selected: props.selected
    }),
    href: props.href,
    title: props.title,
    onClick: props.onClick
  },
    props.label
  )
}

SimpleNavItem.propTypes = {
  // Values
  bemEntity: PropTypes.instanceOf(BemEntity),
  href: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.node,
  selected: PropTypes.bool,
  title: PropTypes.string,
  // Callbacks
  onClick: PropTypes.func
}

// SimpleNav component

function SimpleNav(props) {
  const bemEntity = props.bemEntity || defaultBemEntity
  return React.createElement('nav', {
    className: classNames(
      props.className,
      bemEntity.block()
    )
  }, props.items.map(item => {
    const itemProps = Object.assign({
      bemEntity,
      key: item.id,
      selected: item.id === props.selectedItemId
    }, item)
    return React.createElement(SimpleNavItem, itemProps)
  }))
}

SimpleNav.propTypes = {
  bemEntity: PropTypes.instanceOf(BemEntity),
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(SimpleNavItem.propTypes)),
  selectedItemId: PropTypes.string
}

// Exports

module.exports = Object.assign(SimpleNav, {
  SimpleNavItem
})
